import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  CommonService,
  CONSTANT,
  LoaderService,
  ObservableService,
  OrderService,
} from '@bst-frontend/shared';
CONSTANT;

@Component({
  selector: 'bst-frontend-left-panel',
  templateUrl: './left-panel.component.html',
  styleUrls: ['./left-panel.component.css'],
})
export class LeftPanelComponent {
  @Input() orderData: any;
  @Input() isPickupLocation = false;
  orderDetails: any;
  @Output() openPickup = new EventEmitter<void>();
  orderStateCode = CONSTANT.orderStateCode;
  showFareDetails = ['admin-pending', 'requested'];
  showInvoiceDownload = ['invoiceUploaded', 'paid'];
  showPaymentReceived = ['paid'];
  oderType = ['part-load-door', 'part-load-office'];
  selectedType: string | undefined;
  truckId: string | undefined;

  get redirectRoute(): string {
    return this.truckId ? `/order/truck-detail/${this.truckId}` : '/order';
  }

  get redirectQueryParams(): any {
    return this.selectedType ? { selectedType: this.selectedType } : {};
  }

  constructor(
    private orderService: OrderService,
    private loader: LoaderService,
    private observableService: ObservableService,
    public _commonService: CommonService,
    private route: ActivatedRoute
  ) {}
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.selectedType = params['selectedType'] || this.selectedType;
      this.truckId = params['truckId'] || this.truckId;
    });
    this.orderDetails = {
      type: this.orderData?.type,
      updatedAt: this.orderData?.updatedAt,
      totals: this.orderData?.totals,
      otherCharges: this.orderData?.otherCharges,
      createdAt: this.orderData?.createdAt,
      createdBy: this.orderData?.createdBy,
      state: this.orderData?.state,
      orderByName: this.orderData?.orderBy?.name,
      historyCompact: this.orderData?.historyCompact,
      subOrders: this.orderData?.subOrders,
    };
  }

  onAddPickupClick() {
    this.openPickup.emit();
  }

  // === DOWNLOAD ===
  async onDownloadPdf() {
    // const a = document.createElement('a');
    // a.href = this.orderData?.invoiceDetail?.invoiceFile?.path || '';
    // a.download =
    //   this.orderData?.invoiceDetail?.invoiceFile?.name || 'invoice.pdf';
    // a.target = '_blank';
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);

    const url = this.orderData?.invoiceDetail?.invoiceFile?.path || '';
    if (!url) {
      return;
    }

    try {
      const res = await fetch(url, { method: 'GET' });

      if (!res.ok) throw new Error('Download failed');

      const blob = await res.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download =
        this.orderData?.invoiceDetail?.invoiceFile?.name || 'invoice.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error('PDF download failed', err);
    }
  }

  async onCreateOrderClick() {
    try {
      this.loader.show();
      await this.orderService
        .updateOrderStatus(
          CONSTANT.orderStatus['BOOK-ORDER'],
          this.orderData._id,
          { note: 'Order created By admin' }
        )
        .toPromise();
      this.observableService.send({ refresh: true });
      // this.loader.hide();
    } catch (error) {
      this.loader.hide();
    }
  }
}
